const chains = [
    {
      label: "Ethereum",
      value: '0x1',
      symbol:'ETH',
      rpcUrl:''
    },
    {
      label: "Polygon",
      value: '0x89',
      symbol:'MATIC',
      rpcUrl:''
    },
    {
      label: "Avalaunch",
      value: '0xa86a',
      symbol:'AV',
      rpcUrl:'https://site1.moralis-nodes.com/sepolia/a962ac12e9044f7e8f2099d18b82c35e'
    },
    {
      label:'Sepolia',
      value:'0xaa36a7',
      symbol:'SepoliaEth',
      rpcUrl:'https://site1.moralis-nodes.com/sepolia/a962ac12e9044f7e8f2099d18b82c35e'
    }

  ]

export default chains